import React from "react";
import { Button, Container } from "react-bootstrap";
import { useRouter } from "../util/router";

function LogoutPage(props) {
  const router = useRouter();
  const styleContainer = {
    height: "92vh",
    backgroundColor: "#f9f9f9",
    fontSize: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const styleButton = {
    display: "block",
    marginBottom: "5px",
  };
  return (
    <>
      {props.appReady && !props.kc.authenticated && (
        <div style={{ height: "92vh" }}>
          <div style={styleContainer}>
            <Container>
              <h1 style={{ fontSize: "xxx-large", paddingBottom: "4%" }}>
                Logout successful
              </h1>
              <Button
                style={styleButton}
                onClick={() => {
                  router.push("/solar/signin");
                }}
              >
                Login
              </Button>
              <Button
                style={styleButton}
                onClick={() => (window.location.href = "/")}
              >
                Back to selection
              </Button>
            </Container>
          </div>
        </div>
      )}
    </>
  );
}

export default LogoutPage;
